<template>
  <v-container id="timesheets-approval" fluid tag="section">
    <v-row>
      <v-col cols="12" md="12">
        <idc-component-timesheets-approval
          v-if="canTimesheetApproval"
          :can-create="canCreate"
          :can-edit="canEdit"
          :can-delete="canDelete"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'IdcPageTimesheetsApproval',
    components: {
      IdcComponentTimesheetsApproval: () => import('@/components/idc/timesheets/approval/Timesheets.vue'),
    },
    props: {
      canCreate: {
        type: Boolean,
        default: () => true,
      },
      canEdit: {
        type: Boolean,
        default: () => true,
      },
      canDelete: {
        type: Boolean,
        default: () => true,
      },
      canTimesheetApproval: {
        type: Boolean,
        default: () => true,
      },
    },
  })
</script>
